export default __webpack_public_path__ + "static/media/bars.53409405.svg";